// extracted by mini-css-extract-plugin
module.exports = {"projects":"Projects_projects__30QMA","unreleased":"Projects_unreleased__JceCd"};